// Korkenkick – Interaktion & Scroll-Motion
// Jede Funktion prüft selbst, ob ihre Section auf der Seite ist. So lassen sich die
// Shopify-Sections einzeln einsetzen, umsortieren oder weglassen.
(function () {
  if (window.__kkApple) return; // Datei wird von jeder Section eingebunden, nur einmal ausführen
  window.__kkApple = true;
  document.documentElement.classList.add("js");

  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const seg = (p, a, b) => clamp((p - a) / (b - a));
  const easeOut = (t) => 1 - (1 - t) * (1 - t); // konstante Verzögerung beim Gleiten
  const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2);
  const scrollers = []; // Funktionen, die bei jedem Scroll-Frame laufen

  /* ---------- Würfelaugen ---------- */
  const PIPS = {
    1: [[50, 50]], 2: [[28, 28], [72, 72]], 3: [[26, 26], [50, 50], [74, 74]],
    4: [[28, 28], [72, 28], [28, 72], [72, 72]], 5: [[26, 26], [74, 26], [50, 50], [26, 74], [74, 74]],
    6: [[28, 24], [72, 24], [28, 50], [72, 50], [28, 76], [72, 76]],
  };
  const pipsHTML = (n) => PIPS[n].map(([x, y]) => `<i style="left:${x}%;top:${y}%"></i>`).join("");

  /* ---------- Würfeltabelle laut Regelwerk + passende Videostellen ---------- */
  // clip = Video, from/to = Abschnitt in Sekunden (aus den HyperFrames-Kompositionen)
  const EVENTS = {
    2: ["Rote Karte", "Dein ganzes Team setzt die nächste Runde aus. Die aktuelle Runde wird noch zu Ende gespielt.", "sonderzahlen-2-10", 0, 7.5],
    3: ["Ecke", "Genau zwei Schüsse: Flanke von der gegnerischen Eckfahne, dann Kopfball von dort, wo die Flanke liegt.", "startpositionen-3-4", 0, 7.7],
    4: ["Freistoß", "Schuss von der Freistoßlinie, ohne Mauer.", "startpositionen-3-4", 7.75, 13.05],
    5: ["Fünferlinie", "Korken auf die eigene 5-Meter-Linie legen und Richtung gegnerisches Tor kicken.", "startpositionen-5-6", 0, 7.45],
    6: ["Sechzehner", "Schuss von der eigenen Strafraumgrenze Richtung gegnerisches Tor.", "startpositionen-5-6", 7.5, 13.05],
    7: ["Eigene Ecke", "Schuss von der eigenen Eckfahne über das ganze Feld.", "startpositionen-7-8", 0, 7.45],
    8: ["Einwurf", "Der Korken wird von der Seitenlinie ins Feld gekickt.", "startpositionen-7-8", 7.5, 13.05],
    9: ["Freistoß mit Mauer", "Jeder Gegenspieler kickt erst einen Mauer-Korken von seiner Eckfahne auf deinen. Trifft er: sofort Elfmeter. Sonst schießt du deinen Freistoß.", "mauer-9b-elfmeter", 0, 0],
    10: ["Abseits", "Nur du setzt in der aktuellen Runde aus.", "sonderzahlen-2-10", 7.55, 13.05],
    11: ["Mittelpunkt", "Schuss vom Anstoßpunkt.", "mittelpunkt-11", 0, 0],
    12: ["Elfmeter", "Direkter Schuss vom Elfmeterpunkt.", "elfmeter-12", 0, 0],
  };

  /* ---------- Navigation ---------- */
  function initNav() {
    const nav = $("#nav");
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 1;
    const burger = $(".nav__burger", nav), mnav = $("#mnav");
    burger.addEventListener("click", () => {
      const open = burger.getAttribute("aria-expanded") !== "true";
      burger.setAttribute("aria-expanded", open);
      burger.setAttribute("aria-label", open ? "Menü schließen" : "Menü öffnen");
      mnav.hidden = !open;
    });
    mnav.addEventListener("click", (e) => {
      if (e.target.tagName === "A") { mnav.hidden = true; burger.setAttribute("aria-expanded", "false"); }
    });
    let lastY = 0;
    scrollers.push(() => {
      const y = scrollY;
      nav.style.transform = y > lastY && y > 400 && mnav.hidden ? "translateY(-110%)" : "none";
      lastY = y;
    });
  }

  /* ---------- Hero-Parallax ---------- */
  function initHero() {
    const bg = $("[data-parallax]");
    if (!bg || bg.dataset.ready || reduce) return;
    bg.dataset.ready = 1;
    scrollers.push(() => {
      const r = bg.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const y = -r.top;
      bg.style.transform = `translateY(${y * 0.25}px) scale(${1 + (y / innerHeight) * 0.08})`;
    });
  }

  /* ---------- Scroll-Story ---------- */
  function initStory() {
    const story = $("#spiel");
    if (!story || story.dataset.ready) return;
    story.dataset.ready = 1;
    // Ein einziger Korken: Anstoß ins +3-Feld, nach der Doppelsechs auf den Elfmeterpunkt gelegt und ins Tor gekickt
    const pitch = $("#pitch"), cap1 = $("#cap1");
    const trail1 = $("#trail1"), trail2 = $("#trail2"), pts1 = $("#pts1"), goalGlow = $("#goalGlow");
    const storyDice = $("#storyDice"), sd1 = $("#sd1"), sd2 = $("#sd2");
    const hudScore = $("#hudScore"), hudPts = $("#hudPts");
    const steps = $$(".step", story), after = $(".story__after", story);
    sd1.innerHTML = pipsHTML(6); sd2.innerHTML = pipsHTML(6);

    // Positionen in % der Mattengrafik (vermessen an matte-komplett.jpg)
    const P = { center: [49.9, 49.7], plus3: [80.2, 42.5], spot: [86.75, 49.7], goal: [97.5, 49.7] };
    const place = (el, x, y) => { el.style.left = x + "%"; el.style.top = y + "%"; };
    const trail = (el, from, to, t, show) => {
      const x = lerp(from[0], to[0], t), len = Math.min(Math.max(0, x - from[0]), 14);
      el.style.top = lerp(from[1], to[1], t) + "%";
      el.style.width = len + "%";
      el.style.left = x - len + "%";
      el.style.opacity = show;
    };

    function render() {
      const r = story.getBoundingClientRect();
      if (r.bottom < -50 || r.top > innerHeight + 50) return;
      const p = clamp(-r.top / (r.height - innerHeight));
      const mobile = innerWidth <= 720;

      const t0 = easeInOut(seg(p, 0, 0.14));
      const tilt = lerp(56, 0, t0), sc = lerp(0.84, 1, t0);

      // 1. Anstoß: Mittelpunkt -> +3-Feld
      const a = seg(p, 0.18, 0.22), s1 = easeOut(seg(p, 0.24, 0.42));
      // 3. Hochnehmen und auf den Elfmeterpunkt legen (nach dem Würfeln)
      const mv = easeInOut(seg(p, 0.58, 0.65)), lift = Math.sin(mv * Math.PI);
      // 4. Elfmeter: Punkt -> Tor
      const s2 = easeOut(seg(p, 0.66, 0.8));
      let c1 = [lerp(P.center[0], P.plus3[0], s1), lerp(P.center[1], P.plus3[1], s1)];
      if (mv > 0) c1 = [lerp(P.plus3[0], P.spot[0], mv), lerp(P.plus3[1], P.spot[1], mv)];
      if (s2 > 0) c1 = [lerp(P.spot[0], P.goal[0], s2), P.spot[1]];
      cap1.style.opacity = a;
      place(cap1, ...c1);
      cap1.style.transform = `rotate(${s1 * 540 + s2 * 400}deg) scale(${lerp(1.6, 1, a) + lift * 0.35})`;
      trail(trail1, P.center, P.plus3, s1, s1 > 0 && s1 < 0.97 ? 0.8 : 0);
      trail(trail2, P.spot, P.goal, s2, s2 > 0 && s2 < 0.97 ? 0.8 : 0);
      const got3 = p > 0.42;
      pts1.style.opacity = got3 ? (p < 0.5 ? 1 : 0.55) : 0;
      pts1.style.transform = `translateY(${got3 ? 0 : 10}px)`;

      const d = seg(p, 0.46, 0.5), dOut = seg(p, 0.6, 0.63);
      storyDice.style.opacity = d * (1 - dOut);
      const roll = 1 - seg(p, 0.46, 0.55);
      sd1.style.transform = `rotate(${roll * 380}deg) translateY(${roll * -30}px)`;
      sd2.style.transform = `rotate(${roll * -300}deg) translateY(${roll * -40}px)`;

      const goal = p > 0.8;
      goalGlow.style.opacity = goal ? 1 - seg(p, 0.86, 0.95) * 0.6 : 0;
      hudScore.textContent = goal ? "1 : 0" : "0 : 0";
      hudPts.textContent = got3 ? "3" : "0";

      const idx = p < 0.17 ? 0 : p < 0.45 ? 1 : p < 0.62 ? 2 : 3;
      steps.forEach((s, i) => s.classList.toggle("is-on", i === idx));
      if (after) after.classList.toggle("is-on", idx >= 1);

      // Kamera: Desktop zeigt die ganze Matte, Handy fährt dem Korken nach
      if (mobile) {
        const W = pitch.offsetWidth;
        let fx = 50;
        if (p > 0.2) fx = lerp(50, c1[0], seg(p, 0.2, 0.42));
        if (p > 0.55) fx = lerp(P.plus3[0], 88, seg(p, 0.55, 0.66));
        if (p > 0.66) fx = lerp(88, 90, seg(p, 0.66, 0.8));
        const tx = clamp(innerWidth / 2 - (fx / 100) * W, innerWidth - W - 8, 8);
        pitch.style.transform = `translate(${tx}px,-50%) rotateX(${tilt}deg) scale(${sc})`;
      } else {
        pitch.style.transform = `rotateX(${tilt}deg) scale(${sc})`;
      }
    }
    scrollers.push(render);
    render();
  }


  /* ---------- Spickzettel: Startpunkt auf der Mini-Matte (Koordinaten der 120-cm-Grafik, 2000 × 714) ---------- */
  const GOAL = [1945, 355];
  const START = {
    2: { card: true, text: "Rote Karte: kein Schuss, dein Team setzt die nächste Runde aus" },
    3: { at: [1915, 28], via: [1700, 290], text: "Gegnerische Eckfahne: Flanke, dann Kopfball von dort, wo sie liegt" },
    4: { at: [1370, 232], text: "Freistoß-Markierung in der gegnerischen Hälfte" },
    5: { at: [182, 300], text: "Eigene Fünferlinie, Schuss übers ganze Feld" },
    6: { at: [337, 470], text: "Eigene Strafraumgrenze, Schuss übers ganze Feld" },
    7: { at: [86, 690], text: "Eigene Eckfahne, Schuss übers ganze Feld" },
    8: { at: [1100, 680], text: "Einwurf-Markierung an der Seitenlinie" },
    9: { at: [1370, 232], wall: true, text: "Freistoß-Markierung, die Mauer kommt von den gegnerischen Eckfahnen" },
    10: { flag: true, text: "Abseits: nur du setzt in dieser Runde aus" },
    11: { at: [999, 355], text: "Anstoßpunkt in der Mitte" },
    12: { at: [1735, 355], text: "Elfmeterpunkt, Schuss aufs gegnerische Tor" },
  };
  function updateCheat(n) {
    const box = $("#cheat");
    if (!box) return;
    $$(".cheat__rows li", box).forEach((li) => li.classList.toggle("is-on", li.dataset.n == n));
    const d = START[n], cap = $("#cheatCap", box), path = $("#cheatPath", box);
    const w1 = $("#cheatWall1", box), w2 = $("#cheatWall2", box);
    $("#cheatCard", box).classList.toggle("is-on", !!d.card);
    $("#cheatFlag", box).classList.toggle("is-on", !!d.flag);
    $("#cheatCap1", box).textContent = d.text;
    const show = !!d.at;
    cap.style.opacity = show ? 1 : 0;
    path.style.opacity = show ? 1 : 0;
    if (show) {
      cap.style.transform = `translate(${d.at[0]}px,${d.at[1]}px)`;
      path.setAttribute("d", d.via
        ? `M${d.at[0]} ${d.at[1]} Q${d.via[0] + 120} ${d.at[1] + 40} ${d.via[0]} ${d.via[1]} L${GOAL[0]} ${GOAL[1]}`
        : `M${d.at[0]} ${d.at[1]} L${GOAL[0]} ${GOAL[1]}`);
    }
    // Mauer: je ein Korken von den gegnerischen Eckfahnen Richtung Schütze
    const wallTo = (g, from, to) => { g.style.transform = `translate(${(d.wall ? to : from)[0]}px,${(d.wall ? to : from)[1]}px)`; g.style.opacity = d.wall ? 1 : 0; };
    wallTo(w1, [1915, 28], [1478, 268]);
    wallTo(w2, [1915, 686], [1500, 330]);
  }

  /* ---------- Würfel + Video-Handy ---------- */
  function initDice() {
    const sec = $("#wuerfel");
    if (!sec || sec.dataset.ready) return;
    sec.dataset.ready = 1;

    // Videoquellen einsammeln
    const SRC = {};
    $$(".dice__sources [data-clip]", sec).forEach((s) => { SRC[s.dataset.clip] = { src: s.dataset.src, poster: s.dataset.poster }; });

    const cubes = [$("#cubeA", sec), $("#cubeB", sec)];
    cubes.forEach((c) => {
      for (let n = 1; n <= 6; n++) {
        const f = $(".f" + n, c);
        f.style.backgroundImage = PIPS[n].map(() => "radial-gradient(circle,#14231b 0 46%,transparent 50%)").join(",") + ",radial-gradient(circle at 30% 25%,#fff,#ece7db 70%)";
        f.style.backgroundSize = PIPS[n].map(() => "16% 16%").join(",") + ",100% 100%";
        f.style.backgroundPosition = PIPS[n].map(([x, y]) => `${((x - 8) / 84) * 100}% ${((y - 8) / 84) * 100}%`).join(",") + ",0 0";
      }
    });

    const chips = $(".chips", sec);
    chips.innerHTML = Object.entries(EVENTS).map(([n, [t]]) =>
      `<button class="chip${n == 2 ? " chip--red" : ""}" data-n="${n}" aria-pressed="${n == 12}"><b>${n}</b><span>${t}</span></button>`).join("");

    const led = $(".led", sec), ledNum = $("#ledNum", sec), ledTitle = $("#ledTitle", sec), ledText = $("#ledText", sec);
    const phone = $(".phone", sec), video = $("#diceVideo", sec), playBtn = $("#dicePlay", sec), soundBtn = $("#diceSound", sec);
    const variants = $("#variants", sec);
    let seg9 = "mauer-9b-elfmeter", current = { clip: "elfmeter-12", from: 0, to: 0 }, sound = false;

    function loadClip(clip, from, to, autoplay) {
      const s = SRC[clip];
      current = { clip, from, to };
      if (!s) return;
      // Ohne Klick nur das Vorschaubild zeigen, damit beim Laden kein Video geladen wird
      if (!autoplay && !video.getAttribute("src")) { video.poster = s.poster || ""; return; }
      if (video.dataset.clip !== clip) {
        video.dataset.clip = clip;
        video.poster = s.poster || "";
        video.preload = "auto";
        if (s.src) { video.src = s.src; video.load(); } else video.removeAttribute("src");
      }
      const start = () => { try { video.currentTime = from; } catch (e) {} if (autoplay && s.src) play(); };
      if (video.readyState >= 1) start(); else video.addEventListener("loadedmetadata", start, { once: true });
      if (!autoplay) { video.pause(); phone.classList.remove("is-playing"); }
    }
    function play() {
      video.muted = !sound;
      const pr = video.play();
      if (pr) pr.catch(() => { video.muted = true; video.play().catch(() => {}); });
      phone.classList.add("is-playing");
    }
    // Abschnitt einer Würfelzahl in Schleife
    video.addEventListener("timeupdate", () => {
      const end = current.to || video.duration;
      if (end && video.currentTime >= end - 0.05) video.currentTime = current.from;
    });

    function showEvent(n, autoplay) {
      const [t, txt, clip, from, to] = EVENTS[n];
      ledNum.textContent = n; ledTitle.textContent = t; ledText.textContent = txt;
      led.classList.toggle("is-red", n == 2);
      led.classList.remove("flash"); void led.offsetWidth; led.classList.add("flash");
      $$(".chip", chips).forEach((c) => c.setAttribute("aria-pressed", c.dataset.n == n));
      variants.hidden = n != 9;
      updateCheat(n);
      loadClip(n == 9 ? seg9 : clip, from, to, autoplay);
    }
    chips.addEventListener("click", (e) => { const c = e.target.closest(".chip"); if (c) showEvent(+c.dataset.n, true); });
    variants.addEventListener("click", (e) => {
      const b = e.target.closest("button"); if (!b) return;
      seg9 = b.dataset.clip;
      $$("button", variants).forEach((x) => x.setAttribute("aria-pressed", x === b));
      loadClip(seg9, 0, 0, true);
    });
    playBtn.addEventListener("click", () => {
      if (video.paused) { if (!video.src) loadClip(current.clip, current.from, current.to, true); else play(); }
      else { video.pause(); phone.classList.remove("is-playing"); }
    });
    soundBtn.addEventListener("click", () => {
      sound = !sound;
      soundBtn.setAttribute("aria-pressed", sound);
      soundBtn.textContent = sound ? "Ton aus" : "Ton an";
      video.muted = !sound;
    });

    // Welche Drehung zeigt welche Zahl nach vorn
    const FACE = { 1: [0, 0], 6: [0, 180], 2: [0, -90], 5: [0, 90], 3: [-90, 0], 4: [90, 0] };
    const spins = [0, 0];
    const setCube = (i, n, spin) => {
      const [rx, ry] = FACE[n];
      spins[i] += spin ? 2 : 0;
      cubes[i].style.transform = `rotateX(${rx + spins[i] * 360 - 12}deg) rotateY(${ry + spins[i] * 360 + 14}deg)`;
    };
    setCube(0, 6); setCube(1, 6);
    $("#rollBtn", sec).addEventListener("click", () => {
      const a = 1 + Math.floor(Math.random() * 6), b = 1 + Math.floor(Math.random() * 6);
      setCube(0, a, true); setCube(1, b, true);
      setTimeout(() => showEvent(a + b, true), reduce ? 0 : 950);
    });
    showEvent(12, false);
  }

  /* ---------- Video-Karussell ---------- */
  function initReel() {
    $$(".clip").forEach((clip) => {
      if (clip.dataset.ready) return;
      clip.dataset.ready = 1;
      const v = $("video", clip);
      $(".clip__play", clip).addEventListener("click", () => {
        if (!v.src && v.dataset.src) v.src = v.dataset.src;
        if (v.paused) {
          $$(".clip video").forEach((o) => { if (o !== v) { o.pause(); o.closest(".clip").classList.remove("is-playing"); } });
          v.muted = false; v.play(); clip.classList.add("is-playing");
        } else { v.pause(); clip.classList.remove("is-playing"); }
      });
    });
  }

  /* ---------- Video-Pop-up für [data-play]-Buttons ---------- */
  let modal;
  function openModal(src, poster, title) {
    if (!modal) {
      modal = document.createElement("dialog");
      modal.className = "kk-modal kk";
      modal.innerHTML = '<div class="kk-modal__box"><video playsinline controls></video><button class="kk-modal__close" aria-label="Video schließen">×</button></div>';
      document.body.appendChild(modal);
      const close = () => { $("video", modal).pause(); modal.close(); };
      $(".kk-modal__close", modal).addEventListener("click", close);
      modal.addEventListener("click", (e) => { if (e.target === modal) close(); });
      modal.addEventListener("close", () => $("video", modal).pause());
      modal.addEventListener("cancel", () => $("video", modal).pause());
    }
    const v = $("video", modal);
    v.poster = poster || ""; v.src = src; v.setAttribute("aria-label", title || "Video");
    modal.showModal();
    v.play().catch(() => {});
  }
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-play]");
    if (!b || !b.dataset.src) return;
    openModal(b.dataset.src, b.dataset.poster, b.dataset.title);
  });


  /* ---------- Anmeldung: nur in der lokalen Vorschau abfangen ---------- */
  function initSignup() {
    const form = $("#signup");
    if (!form || form.dataset.ready || !form.hasAttribute("data-preview")) return;
    form.dataset.ready = 1;
    const msg = $("#signupMsg");
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const v = form.email.value.trim();
      if (!/^\S+@\S+\.\S+$/.test(v)) { msg.textContent = "Bitte gib eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de."; form.email.focus(); return; }
      msg.textContent = "Eingetragen. Wir melden uns zum Anpfiff.";
      form.reset();
    });
  }


  /* ---------- Spielregeln: aktiven Abschnitt im Inhaltsverzeichnis markieren ---------- */
  function initToc() {
    const toc = $(".rules__toc");
    if (!toc || toc.dataset.ready) return;
    toc.dataset.ready = 1;
    const links = $$("a", toc);
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) links.forEach((a) => a.classList.toggle("is-on", a.getAttribute("href") === "#" + e.target.id));
    }), { rootMargin: "-40% 0px -55% 0px" });
    links.forEach((a) => { const t = $(a.getAttribute("href")); if (t) io.observe(t); });
  }


  /* ---------- Einblendungen, Verschluss-Bild, Kronkorken im Hero ---------- */
  function initReveal() {
    // Geschwister in einer Gruppe nacheinander (60–90 ms Versatz)
    $$("[data-reveal]").forEach((el) => {
      if (el.style.getPropertyValue("--d")) return;
      const sibs = [...el.parentElement.children].filter((c) => c.hasAttribute("data-reveal"));
      el.style.setProperty("--d", Math.min(sibs.indexOf(el), 5));
    });
    const targets = $$("[data-reveal]:not(.is-in), .shutter:not(.is-in)");
    if (!("IntersectionObserver" in window)) { targets.forEach((t) => t.classList.add("is-in")); return; }
    // Ein komplett zugeschnittenes Bild (clip-path) gilt nie als sichtbar: dafür den Rahmen beobachten
    const watch = new Map();
    targets.forEach((t) => watch.set(t.classList.contains("shutter") ? t.parentElement : t, t));
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { watch.get(e.target).classList.add("is-in"); io.unobserve(e.target); }
    }), { rootMargin: "0px 0px -12% 0px", threshold: 0.1 });
    watch.forEach((_, w) => io.observe(w));
  }
  function initHeroCap() {
    const cap = $(".hero__cap svg");
    if (!cap || cap.dataset.ready || reduce) return;
    cap.dataset.ready = 1;
    // Der Kronkorken dreht sich beim Scrollen weiter, als wäre er gerade angekickt
    scrollers.push(() => {
      const r = cap.getBoundingClientRect();
      if (r.bottom < 0) return;
      cap.style.transform = `rotate(${scrollY * 0.06}deg)`;
    });
  }

  function initAll() { initNav(); initHero(); initStory(); initDice(); initReel(); initSignup(); initToc(); initReveal(); initHeroCap(); }

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; scrollers.forEach((f) => f()); });
  };
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  // Shopify Theme-Editor: Section neu geladen
  document.addEventListener("shopify:section:load", () => { initAll(); onScroll(); });
})();
